<template>
  <GlobalWindow
    :visible.sync="isVisibled"
    :show="true"
    title="复制列表"
    width="80%"
  >
    <!-- @confirm="confirm" -->
    <div class="app-container">
      <el-card style="box-shadow: none; border: none">
        <!--  <div
          slot="header"
          class="header"
        >
          <span>复制广告(Mp)</span>
          <span>广告主：《{{ this.$route.query.account_name }}》&nbsp;&nbsp;<span>服务商：{{ this.$route.query.service_name }}</span></span>
        </div> -->
        <div class="top">
          <el-row :gutter="10">
            <el-col :span="4">
              <el-input
                v-model="mpAdvertListParams.job_id"
                placeholder="请输入广告ID"
              >
                <i slot="prefix" class="el-input__icon el-icon-search" />
              </el-input>
            </el-col>
            <el-button type="primary" @click="searchMpAdvert">搜索</el-button>
            <el-button
              type="warning"
              @click="resetMpAdvertList"
            >重置</el-button>
            <el-button
              type="danger"
              @click="againMpAdvertList"
            >任务重试</el-button>
          </el-row>
        </div>
        <div class="main">
          <el-table
            v-loading="loading"
            :data="mpAdvertList"
            style="width: 100%"
            :row-key="getRowKeys"
            @select="multipleChoice"
            @select-all="multipleChoice"
          >
            <!-- <el-table-column
              type="selection"
              width="55"
              :data-index="1"
              :reserve-selection="true"
            /> -->
            <el-table-column prop="id" label="记录id" align="center" />
            <el-table-column prop="job_id" label="任务id" align="center" />
            <el-table-column
              prop="source_account_id"
              label="来源广告账户id"
              align="center"
              width="180"
            />
            <!-- <el-table-column
              prop="source_account_name"
              label="来源广告账户名称"
              align="center"
              width="230"
            /> -->
            <el-table-column
              prop="source_adgroup_id"
              label="来源广告组id"
              align="center"
              width="180"
            >
              <template scope="scope">
                {{ scope.row.source_adgroup_id }}
              </template></el-table-column>
            <el-table-column
              prop="fail_reason"
              label="失败原因
"
              align="center"
              width="480"
            />
            <el-table-column
              prop="target_account_id"
              label="目标广告主id"
              align="center"
            />
            <el-table-column
              prop="target_adgroup_id"
              label="目标广告组id"
              align="center"
            />
            <el-table-column
              prop="target_adgroup_name"
              label="目标广告组名称"
              align="center"
            />
            <el-table-column prop="status" label="状态" align="center">
              <template scope="scope">
                {{
                  scope.row.status == 1
                    ? '成功'
                    : scope.row.status == 2
                      ? '失败'
                      : scope.row.status == 3
                        ? '终止'
                        : '待处理'
                }}
              </template></el-table-column>
            <el-table-column
              prop="updated_at"
              label="更新时间"
              align="center"
            />
            <el-table-column
              prop="created_at"
              label="创建时间"
              align="center"
            />
          </el-table>
          <Pagination
            :total="pageTotal"
            :page.sync="mpAdvertListParams.page"
            :limit.sync="mpAdvertListParams.page_size"
            :page-sizes="[mpAdvertListParams.page_size]"
            @pagination="fetchMpAdvertList"
          />
        </div>
      </el-card>
    </div>
  </GlobalWindow>
</template>
<script>
import Pagination from '@/components/Pagination/index'
import { job_record_list, retry_failed_record } from '@/api/customer.js'
import GlobalWindow from '@/components/GlobalWindow.vue'
export default {
  name: 'CopyMpAdvertManage',
  components: {
    Pagination,
    GlobalWindow
  },
  data() {
    return {
      isVisibled: false,
      loading: false,
      drawerTitle: null,
      pageTotal: 0,
      isDetailStatus: false,
      mpAdvertListParams: {
        job_id: null,
        page: 1,
        page_size: 10
      },
      mpAdvertList: [],
      isShow: false
    }
  },
  created() {},
  methods: {
    multipleChoice(arr) {
      this.adgroup_ids = arr.map((item) => {
        return item.adgroup_id
      })
      this.adgroup_items = arr
    },
    againMpAdvertList() {
      this.$confirm('请确认修改完广告再重试', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async() => {
          let job_ids = []
          if (this.mpAdvertList.length === 0) {
            job_ids = [this.mpAdvertListParams.job_id]
          } else {
            job_ids = Array.from(
              new Set(this.mpAdvertList.map((v) => Number(v.job_id)))
            )
          }
          const res = await retry_failed_record({ job_ids })
          if (res.code === 0) {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.isVisibled = false
          }
        })
        .catch(() => {})
    },
    // 获取广告列表
    fetchMpAdvertList() {
      this.loading = true
      this.isShow = false
      job_record_list(this.mpAdvertListParams).then((res) => {
        console.log(res)
        this.mpAdvertList = res.data.list
        this.pageTotal = res.data.total
        this.loading = false
        // const asyncParams = {
        //   account_id: this.$route.query.account_id,
        //   campaign_ids: []
        // }
        // res.data.list.forEach(item => {
        //   asyncParams.campaign_ids.push(item.ad_id)
        //   item.isDetailStatus = false
        //   this.isShow = true
        // })
        // if (res.data.list.length) {
        //   // this.fetchMpAdvertListAsyncData(asyncParams)
        // }
      })
    },
    // 获取广告异步数据
    // fetchMpAdvertListAsyncData(params) {
    //   this.isShow = false
    //   mpAdvertListAsyncData(params).then(res => {
    //     console.log(res, '===')
    //     this.mpAdvertList.map((item, index) => {
    //       res.data.map(ite => {
    //         if (item.ad_id === ite.campaign_id) {
    //           item.asyncData = ite
    //         }
    //       })
    //     })
    //     this.isShow = true
    //   })
    // },
    // 判断数据是否刷新完成
    isFreshOk() {
      /* if (!this.isShow) {
        this.$message({
          message: '请等待数据刷新完成',
          type: 'error'
        })
        return false
      } */
      return true
    },
    getRowKeys(row) {
      return row.id
    },
    handleCopyMpAdvert(rowData) {
      console.log('rowData:', rowData)
      if (this.isFreshOk()) {
        this.$refs.copyMpAdDialog.open(rowData)
      }
    },
    // 搜索广告
    searchMpAdvert() {
      this.mpAdvertListParams.page = 1
      this.fetchMpAdvertList()
    },
    // 重置广告列表
    resetMpAdvertList() {
      this.mpAdvertListParams = {
        job_id: null,
        page: 1,
        page_size: 10
      }
      this.fetchMpAdvertList()
    },
    handleShowDetail(index, row) {
      this.$set(this.mpAdvertList, index, { ...row, isDetailStatus: true })
    },
    open(item) {
      console.log(4)

      this.isVisibled = true
      this.mpAdvertListParams.job_id = item.id
      this.fetchMpAdvertList()
    },
    confirm() {
      console.log('this.copyMpAdvertParams:', this.copyMpAdvertParams)
      this.handleCopyMpAdvert(this.copyMpAdvertParams)
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
}
.main {
  margin-top: 20px;
  video {
    width: 100px;
    height: 100px;
    object-fit: fill;
  }
  .shadowBox {
    display: flex;
    height: 100px;
    align-items: center;
    justify-content: center;
  }
}
.app-container {
  padding: 0px;
}
</style>
